/*global angular*/
/*global _*/

import 'jquery';
import 'ng-dialog';
import 'angular-sanitize';
import 'angular-ui-bootstrap';
import AppHelper from '../../../components/helpers/AppHelper';
import '../../../main/apt';

var module = angular.module('historyMain', [
  'ui.bootstrap',
  'ngDialog',
  'ngSanitize',
])
.service('AppHelper',AppHelper)
.controller('HistoryCtrl', ['$scope', 'AppHelper', 'apt', 'ngDialog', '$uibModal', '$q', function ($scope,AppHelper,apt,ngDialog, $uibModal, $q) {

  $scope.init = function() {
    function getClink() {
      var deferred = $q.defer();
      $scope.loading = true;
      const clinkId = $scope.$ctrl.clink.clinkId || $scope.$ctrl.clink.clink_id;

      AppHelper.getClink( {'clinkid':clinkId, 'history':true},
        function(data) {
          $scope.clink = data;
        },
        function() {
          deferred.reject();
          $scope.message = 'Could not get cLink configuration';
            ngDialog.open({
                template: 'static/dialogs/error.html',
                scope: $scope
            });
        },
        function() {
          $scope.loading = false;
          deferred.resolve();
        }
      );
      return deferred.promise;
    };

    function lookupAppName() {
      var deferred = $q.defer();
      var plat = 'ios';
      if( $scope.$ctrl.clink.clinkid && $scope.$ctrl.clink.clinkid.indexOf('.') !== -1 ) {
        plat = 'android';
      }
      if( $scope.$ctrl.clink.clink_id && $scope.$ctrl.clink.clink_id.indexOf('.') !== -1 ) {
        plat = 'android';
      }

      var params = {};
      params[plat] = $scope.clink.app_id;

      AppHelper.getAppInfo( params, 
        function(data) {
          $scope.appName = data[$scope.clink.app_id];
        },
        function() {
          deferred.reject();
          console.error('failed to get app name');
        },
        function() {
          deferred.resolve();
        }
      );
      return deferred.promise;
    };

    function lookupPublisherName() {
      var deferred = $q.defer();
      AppHelper.getPublishersFull( { clinkable: 'true' },
        function(data) {
          _.forEach( data, function( pub ) {
            if( pub.pubid === $scope.clink.pub_id ) {
              $scope.pubName = pub.publisherName
            }
          });
        },
        function() {
          deferred.reject();
          console.error('failed to get publisher name');
        },
        function() {
          deferred.resolve();
        }
      );
      return deferred.promise;
    };

    getClink().then( function() {
      lookupAppName().then( function() {} );
      lookupPublisherName().then( function() {} );
    });

  };

  $scope.getCampaignsStr = function( camps ) {
    var c = [];
    _.map( camps, function( camp ) {
      c.push(camp.source + ':' + camp.campaign_id);
    });
    return c.join('<br>');
  };

  $scope.getCounterBidStr = function( allowCounterBid ) {
    if ( allowCounterBid === true ) {
      return "Allow";
    }
    if ( allowCounterBid === false ) {
      return "Disable";
    }
    return "Default";
  };

  $scope.styleForChangedField = { border: "4px solid green" };

  $scope.getStyleForChangedField = function( prop, index ) {
    if (index > 0 ) {
      switch(prop) {
        case "campaigns":
          if ($scope.getCampaignsStr($scope.clink.configs[index][prop]) !== $scope.getCampaignsStr($scope.clink.configs[index-1][prop])) {
            return $scope.styleForChangedField;
          }
          break;
        case "allow_counter_bid":
        case "allow_counter_bid_override":
          if ($scope.getCounterBidStr($scope.clink.configs[index][prop]) !== $scope.getCounterBidStr($scope.clink.configs[index-1][prop])) {
            return $scope.styleForChangedField;
          }
          break;
        default:
          if ($scope.clink.configs[index][prop] !== $scope.clink.configs[index-1][prop]) {
            return $scope.styleForChangedField;
          }
          break;
      }
    }
    return "";
  };
}]);

export default module;